{
  "name": "@aws-sdk/nested-clients",
  "version": "3.997.11",
  "description": "Nested clients for AWS SDK packages.",
  "main": "./dist-cjs/index.js",
  "module": "./dist-es/index.js",
  "types": "./dist-types/index.d.ts",
  "scripts": {
    "build": "yarn lint && concurrently 'yarn:build:types' 'yarn:build:es' && yarn build:cjs",
    "build:cjs": "node ../../scripts/compilation/inline nested-clients",
    "build:es": "tsc -p tsconfig.es.json",
    "build:include:deps": "yarn g:turbo run build -F=\"$npm_package_name\"",
    "build:types": "tsc -p tsconfig.types.json",
    "build:types:downlevel": "downlevel-dts dist-types dist-types/ts3.4",
    "clean": "premove dist-cjs dist-es dist-types tsconfig.cjs.tsbuildinfo tsconfig.es.tsbuildinfo tsconfig.types.tsbuildinfo",
    "lint": "node ../../scripts/validation/submodules-linter.js --pkg nested-clients",
    "test": "yarn g:vitest run",
    "test:watch": "yarn g:vitest watch"
  },
  "engines": {
    "node": ">=20.0.0"
  },
  "sideEffects": false,
  "author": {
    "name": "AWS SDK for JavaScript Team",
    "url": "https://aws.amazon.com/javascript/"
  },
  "license": "Apache-2.0",
  "dependencies": {
    "@aws-crypto/sha256-browser": "5.2.0",
    "@aws-crypto/sha256-js": "5.2.0",
    "@aws-sdk/core": "^3.974.13",
    "@aws-sdk/signature-v4-multi-region": "^3.996.28",
    "@aws-sdk/types": "^3.973.9",
    "@smithy/core": "^3.24.3",
    "@smithy/fetch-http-handler": "^5.4.3",
    "@smithy/node-http-handler": "^4.7.3",
    "@smithy/types": "^4.14.2",
    "tslib": "^2.6.2"
  },
  "devDependencies": {
    "concurrently": "7.0.0",
    "downlevel-dts": "0.10.1",
    "premove": "4.0.0",
    "typescript": "~5.8.3"
  },
  "typesVersions": {
    "<4.5": {
      "dist-types/*": [
        "dist-types/ts3.4/*"
      ]
    }
  },
  "files": [
    "./cognito-identity.d.ts",
    "./cognito-identity.js",
    "./signin.d.ts",
    "./signin.js",
    "./sso-oidc.d.ts",
    "./sso-oidc.js",
    "./sso.d.ts",
    "./sso.js",
    "./sts.d.ts",
    "./sts.js",
    "dist-*/**"
  ],
  "browser": {
    "./dist-es/submodules/cognito-identity/runtimeConfig": "./dist-es/submodules/cognito-identity/runtimeConfig.browser",
    "./dist-es/submodules/signin/runtimeConfig": "./dist-es/submodules/signin/runtimeConfig.browser",
    "./dist-es/submodules/sso-oidc/runtimeConfig": "./dist-es/submodules/sso-oidc/runtimeConfig.browser",
    "./dist-es/submodules/sso/runtimeConfig": "./dist-es/submodules/sso/runtimeConfig.browser",
    "./dist-es/submodules/sts/runtimeConfig": "./dist-es/submodules/sts/runtimeConfig.browser"
  },
  "react-native": {},
  "homepage": "https://github.com/aws/aws-sdk-js-v3/tree/main/packages/nested-clients",
  "repository": {
    "type": "git",
    "url": "https://github.com/aws/aws-sdk-js-v3.git",
    "directory": "packages/nested-clients"
  },
  "exports": {
    "./package.json": "./package.json",
    "./sso-oidc": {
      "types": "./dist-types/submodules/sso-oidc/index.d.ts",
      "module": "./dist-es/submodules/sso-oidc/index.js",
      "node": "./dist-cjs/submodules/sso-oidc/index.js",
      "import": "./dist-es/submodules/sso-oidc/index.js",
      "require": "./dist-cjs/submodules/sso-oidc/index.js"
    },
    "./sts": {
      "types": "./dist-types/submodules/sts/index.d.ts",
      "module": "./dist-es/submodules/sts/index.js",
      "node": "./dist-cjs/submodules/sts/index.js",
      "import": "./dist-es/submodules/sts/index.js",
      "require": "./dist-cjs/submodules/sts/index.js"
    },
    "./signin": {
      "types": "./dist-types/submodules/signin/index.d.ts",
      "module": "./dist-es/submodules/signin/index.js",
      "node": "./dist-cjs/submodules/signin/index.js",
      "import": "./dist-es/submodules/signin/index.js",
      "require": "./dist-cjs/submodules/signin/index.js"
    },
    "./cognito-identity": {
      "types": "./dist-types/submodules/cognito-identity/index.d.ts",
      "module": "./dist-es/submodules/cognito-identity/index.js",
      "node": "./dist-cjs/submodules/cognito-identity/index.js",
      "import": "./dist-es/submodules/cognito-identity/index.js",
      "require": "./dist-cjs/submodules/cognito-identity/index.js"
    },
    "./sso": {
      "types": "./dist-types/submodules/sso/index.d.ts",
      "module": "./dist-es/submodules/sso/index.js",
      "node": "./dist-cjs/submodules/sso/index.js",
      "import": "./dist-es/submodules/sso/index.js",
      "require": "./dist-cjs/submodules/sso/index.js"
    }
  }
}
